import type { Theme } from '@mui/material';

import type { HistoricalData, KpiLabels } from 'src/types/dashboard';
import type { GroupData } from 'src/components/dashboard/charts/GroupedBarChart';

export const getColorMap = (theme: Theme): [string, string][] => [
  [theme.colors.secondary[500], theme.colors.secondary[800]],
  [theme.colors.secondary[100], theme.colors.secondary[800]],
];

export const getGroupData = (
  focalData: HistoricalData,
  ancestralData: HistoricalData,
  kpiLabels: KpiLabels,
  kpiSelection: string[],
): GroupData[] => {
  if (!kpiSelection[0]) return [];

  // this widget expects only one kpi
  const kpi = kpiSelection[0];
  return Object.entries(focalData).map(([label, values], i, source) => {
    const kpiLabel = kpiLabels[kpi];
    return [
      label, // x-axis label (year)
      [
        [values[kpi], kpiLabel],
        [ancestralData?.[label]?.[kpi], kpiLabel],
      ],
      source.length === i + 1, // indicator for the latest item
    ];
  });
};
